import { Fragment, type ReactNode } from "react"

const DECIMAL_CENTS = /(?<=\d)([.,])(\d{2})(?!\d)/g

interface CentsProps {
  children: ReactNode
}

const asText = (children: ReactNode): string | null => {
  if (typeof children === "string") return children
  if (Array.isArray(children) && children.every((child) => typeof child === "string")) return children.join("")
  return null
}

export const Cents = ({ children }: CentsProps) => {
  const text = asText(children)
  if (text == null) return <>{children}</>
  const nodes: ReactNode[] = []
  let cursor = 0
  for (const match of text.matchAll(DECIMAL_CENTS)) {
    const [whole, separator, cents] = match
    nodes.push(
      <Fragment key={match.index}>
        {text.slice(cursor, match.index)}
        <span className="sr-only">{separator}</span>
        <span className="cents">{cents}</span>
      </Fragment>
    )
    cursor = match.index + whole.length
  }
  if (cursor === 0) return text
  nodes.push(text.slice(cursor))
  return <>{nodes}</>
}
